export function RightIcon({ className = "" }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="arrow-right">
        <g id="Vector">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.33203 9.99967C3.33203 9.58022 3.67207 9.24018 4.09152 9.24018H15.9059C16.3253 9.24018 16.6654 9.58022 16.6654 9.99967C16.6654 10.4191 16.3253 10.7592 15.9059 10.7592H4.09152C3.67207 10.7592 3.33203 10.4191 3.33203 9.99967Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.46166 3.55546C9.75826 3.25886 10.2391 3.25886 10.5357 3.55546L16.4429 9.46263C16.7395 9.75923 16.7395 10.2401 16.4429 10.5367L10.5357 16.4439C10.2391 16.7405 9.75826 16.7405 9.46166 16.4439C9.16505 16.1473 9.16505 15.6664 9.46166 15.3698L14.8318 9.99967L9.46166 4.62954C9.16505 4.33294 9.16505 3.85206 9.46166 3.55546Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
}
